import * as React from "react"

function ArrowUpSvg(props) {
  return (
    <svg viewBox="0 0 24 14.8" {...props}>
      <path d="M12 0l12 12-2.8 2.8L12 5.6l-9.2 9.2L0 12z" fill="#0068FF" />
    </svg>
  )
}

export default ArrowUpSvg
